"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchProducts = void 0;
const react_1 = require("react");
const predicate_language_1 = require("@groupby/predicate-language");
const react_redux_1 = require("react-redux");
const hooks_1 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const useFetchProducts = (countOffset, limitProducts, activeFilter) => {
    const total = (0, store_1.useProductsTotal)();
    const { addError } = (0, hooks_1.useNotification)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isExclusionModeOn = (0, store_1.useIsExclusionModeOn)();
    const selectedProductIds = (0, store_1.useSelectedProductIds)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const token = (0, hooks_1.useToken)();
    const filter = new predicate_language_1.PredicateBuilder(activeFilter);
    filter.and((0, predicate_language_1.where)((0, predicate_language_1.field)('id'), isExclusionModeOn ? '!@<' : '@<', selectedProductIds.map((id) => (0, predicate_language_1.uuid)(id))));
    const client = (0, hooks_1.useEnrichClient)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [products, setProducts] = (0, react_1.useState)([]);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const onCheckProduct = (id) => {
        setProducts(products.map((el) => ((el.id === id) ? Object.assign(Object.assign({}, el), { isChecked: !el.isChecked }) : el)));
        dispatch((0, store_1.addSelectedProductId)(id));
    };
    (0, react_1.useEffect)(() => {
        if (token) {
            setLoading(true);
            client.products.getMany({
                filter,
                page: { limit: limitProducts, offset: countOffset },
            }).then((data) => {
                setProducts((prevProducts) => [...prevProducts, ...data.map((elem) => (Object.assign(Object.assign({}, elem), { isChecked: true })))]);
                setHasMore(countOffset + limitProducts < total);
                setLoading(false);
            }).catch(() => addError(t({ key: 'PRODUCT_EDITOR_TABLE_LOADING_ERROR' })));
        }
    }, [countOffset, token]);
    return {
        loading, products, hasMore, onCheckProduct,
    };
};
exports.useFetchProducts = useFetchProducts;
exports.default = exports.useFetchProducts;
